/** Ошибка входа с уже готовым текстом для админа (getErrorMessage). */
export class LoginError extends Error {
  readonly original: unknown;
  constructor(message: string, original: unknown) {
    super(message);
    this.name = 'LoginError';
    this.original = original;
  }
}
